/* tslint:disable */
/* eslint-disable */
/**
 * Easy Templates Internal API
 * This is an internal REST API for Easy Templates application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IssueCopyRequest
 */
export interface IssueCopyRequest {
    /**
     * Name of the issue (technically, the value of the Summary field)
     * @type {string}
     * @memberof IssueCopyRequest
     */
    name: string;
}

/**
 * Check if a given object implements the IssueCopyRequest interface.
 */
export function instanceOfIssueCopyRequest(value: object): value is IssueCopyRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function IssueCopyRequestFromJSON(json: any): IssueCopyRequest {
    return IssueCopyRequestFromJSONTyped(json, false);
}

export function IssueCopyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): IssueCopyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function IssueCopyRequestToJSON(value?: IssueCopyRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
    };
}

